import { Box } from '@chakra-ui/react';
import { CalendarDate, isSameMonth } from '@internationalized/date';
import { FC, useRef } from 'react';
import { useCalendarCell } from 'react-aria';
import { CalendarState } from 'react-stately';
import { Button } from '../Button';

interface CalendarCellProps {
    state: CalendarState;
    date: CalendarDate;
    currentMonth: CalendarDate;
}

export const CalendarCell: FC<CalendarCellProps> = ({
    state,
    date,
    currentMonth,
}) => {
    const ref = useRef(null);
    const { cellProps, buttonProps, isSelected, isInvalid, formattedDate } =
        useCalendarCell({ date }, state, ref);

    const isOutsideMonth = !isSameMonth(currentMonth, date);

    return (
        <Box as="td" {...cellProps} textAlign="center">
            <Button
                {...buttonProps}
                onClickEvent="Calendar Cell Button Clicked"
                ref={ref}
                hidden={isOutsideMonth}
                size="xs"
                fontSize="md"
                colorScheme={isInvalid ? 'red' : 'blue'}
                variant={isSelected ? 'solid' : 'ghost'}
                height={10}
                width={10}
            >
                {formattedDate}
            </Button>
        </Box>
    );
};
